import { list } from 'src/app/common/classes/request-builder';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export class TrazabilidadListsDefinition {

    public proveedores: TypeAheadInterface<Compradores> = list(['...', null]);
    public fincas: TypeAheadInterface<FincasModel> = list(['...', null]);
    public sectores: TypeAheadInterface<SectorModel> = list(['...', null]);
    public parcelas: TypeAheadInterface<ParcelasModel> = list(['...', null]);
    public cultivos: TypeAheadInterface<VisitasVariedadMesModel> = list(['...', null]);
    public variedades: TypeAheadInterface<VisitasVariedadMesModel> = list(['...', null]);

    public incidencias: TypeAheadInterface<string> = list(
        ['...', null],
        'Frío',
        'Caída Cajas',
        'Plagas',
        'Otros Problemas'
    );

    public formatos: TypeAheadInterface<string> = list(
        ['...', null],
        'ARB,10,5',
        'MIX 14',
        'MIX 17',
        'T/BI 19',
        'T/27',
        'TRIO 15',
        'PYR/23',
        'VISMART',
        'TRIO 13'
    );
}